import { render, staticRenderFns } from "./deleteFile.vue?vue&type=template&id=094da3e9&scoped=true"
import script from "./deleteFile.vue?vue&type=script&lang=js"
export * from "./deleteFile.vue?vue&type=script&lang=js"
import style0 from "./deleteFile.vue?vue&type=style&index=0&id=094da3e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094da3e9",
  null
  
)

export default component.exports